module.exports = __webpack_public_path__ + "media/images/icon-favorite-active-5bfdace949915bdd28bd817d0007fabb.svg";